import { useState, useEffect, useContext } from 'react'
import ContextStates from '../../context/ContextStates'

const FViewDataCliente = () => {
    const [domActual, setDomActual] = useState('')
    const [obsActual, setObsActual] = useState('')
    const { clienteSelected } = useContext(ContextStates);

    useEffect(() => {
        if (typeof clienteSelected.domicilios!=='undefined') {
            clienteSelected.domicilios.forEach(element => {
                if (element.actual==='1') {
                    setDomActual(element.domicilio)
                    setObsActual(element.observaciones)
                }
            });
        }
        
    }, [clienteSelected])

    return (
        <div className="w-full mx-auto p-5 rounded-2xl">
            <div className="transition-all w-full sm:p-3">
                <div className="sm:items-start mt-5">
                    <p className="block mt-5 text-gray-600 uppercase"><span className='font-bold'>Apellido:</span> {clienteSelected.apellido}</p>
                </div>
                <div className="sm:items-start mt-5">
                    <p className="block mt-5 text-gray-600 uppercase"><span className='font-bold'>Nombre:</span> {clienteSelected.nombre}</p>
                </div>
                <div className="sm:items-start mt-5">
                    <p className="block text-gray-600 uppercase"><span className='font-bold'>Domicilio:</span> {domActual}</p>
                </div>
                <div className="sm:items-start mt-5">
                    <p className="block text-gray-600 uppercase"><span className='font-bold'>Observaciones del Domicilio:</span> {obsActual}</p>
                </div>
                <div className="sm:items-start mt-5">
                    <p className="block text-gray-600 uppercase"><span className='font-bold'>Teléfono:</span> {clienteSelected.telefono}</p>
                </div>
            </div>
        </div>
    )
}

export default FViewDataCliente